const $7d7683134fbb8fec$export$d16af6ab0c202bae = "https://snippet.meticulous.ai";


const $01ff17ace345060a$export$1595d9c512db1389 = (version)=>{
    if (version == null) return "v1";
    return `v/${version}`;
};


const $5d774bdb3a883001$var$DEFAULT_MAX_MS_TO_BLOCK_FOR = 2000;
const $5d774bdb3a883001$export$f80553af9d70f9fd = async (options)=>{
    if (window.Meticulous?.isRunningAsTest) {
        console.debug("Running as part of a Meticulous test case, so skipping loading the Meticulous recorder.");
        return {
            stopRecording: async ()=>{
            // No op
            }
        };
    }
    // Try to load the recorder and silence any initialisation error.
    return await $5d774bdb3a883001$var$unsafeLoadAndStartRecorder(options).catch((error)=>{
        console.error(error);
        return {
            stopRecording: async ()=>{
            // No op
            }
        };
    });
};
const $5d774bdb3a883001$var$unsafeLoadAndStartRecorder = ({ projectId: projectId, recordingToken: recordingToken, uploadIntervalMs: uploadIntervalMs, snapshotLinkedStylesheets: snapshotLinkedStylesheets, commitHash: commitHash, maxMsToBlockFor: maxMsToBlockFor_, snippetsBaseUrl: snippetsBaseUrl, forceRecording: forceRecording, middleware: middleware, responseSanitizers: responseSanitizers, isProduction: isProduction, version: version })=>{
    let abandoned = false;
    return new Promise((resolve, reject)=>{
        const maxMsToBlockFor = maxMsToBlockFor_ ?? $5d774bdb3a883001$var$DEFAULT_MAX_MS_TO_BLOCK_FOR;
        if (maxMsToBlockFor > 0) setTimeout(()=>{
            abandoned = true;
            resolve({
                stopRecording: async ()=>{
                // No op: we never started recording
                }
            });
        }, maxMsToBlockFor);
        const script = document.createElement("script");
        script.type = "text/javascript";
        const baseSnippetsUrl = snippetsBaseUrl || (0, $7d7683134fbb8fec$export$d16af6ab0c202bae);
        script.src = new URL(`${version != null ? "record/" : ""}${(0, $01ff17ace345060a$export$1595d9c512db1389)(version ?? null)}/meticulous-manual-init.js`, baseSnippetsUrl).href;
        // Setup configuration
        const typedWindow = window;
        typedWindow.METICULOUS_RECORDING_TOKEN = recordingToken ?? projectId;
        if (uploadIntervalMs !== undefined) typedWindow.METICULOUS_UPLOAD_INTERVAL_MS = uploadIntervalMs;
        if (commitHash !== undefined) typedWindow.METICULOUS_APP_COMMIT_HASH = commitHash;
        if (snapshotLinkedStylesheets !== undefined) typedWindow.METICULOUS_SNAPSHOT_LINKED_STYLESHEETS = snapshotLinkedStylesheets;
        if (forceRecording !== undefined) typedWindow.METICULOUS_FORCE_RECORDING = forceRecording;
        if (isProduction !== undefined) typedWindow.METICULOUS_IS_PRODUCTION_ENVIRONMENT = isProduction;
        if (responseSanitizers != null && responseSanitizers.length > 0) typedWindow.METICULOUS_NETWORK_RESPONSE_SANITIZERS = responseSanitizers;
        if (middleware != null && middleware.length > 0) typedWindow.METICULOUS_RECORDER_MIDDLEWARE_V1 = middleware;
        script.onload = function() {
            if (abandoned) {
                console.debug("Meticulous snippet abandoned due to max blocking time reached.");
                // At this point the promise has already resolved.
                return;
            }
            const initialiseRecorder = window.__meticulous?.initialiseRecorder;
            if (typeof initialiseRecorder !== "function") {
                reject("Meticulous recorder failed to initialise.");
                return;
            }
            try {
                initialiseRecorder();
            } catch (error) {
                reject(error);
            }
            resolve({
                stopRecording: async ()=>{
                    const stopRecording = window.__meticulous?.stopRecording;
                    if (!stopRecording) throw new Error("Recorder not initialised: window.__meticulous.stopRecording is not defined.");
                    await stopRecording();
                    return;
                }
            });
        };
        script.onerror = ()=>{
            reject("Meticulous recorder failed to initialise.");
        };
        document.head.appendChild(script);
    });
};
const $5d774bdb3a883001$export$9da0cde53b499187 = $5d774bdb3a883001$var$unsafeLoadAndStartRecorder;





const $d91c442ec5d010f4$var$DEFAULT_MAX_MS_TO_BLOCK_FOR = 2000;
const $d91c442ec5d010f4$export$c0c9d1ed5ecb2675 = async (options)=>{
    let requestedToStopIntercepting = false;
    let disposedEarlyNetworkRecorder = false;
    const stopIntercepting = async ()=>{
        requestedToStopIntercepting = true;
        const disposeFunction = window?.__meticulous?.earlyNetworkRecorder?.dispose;
        if (disposeFunction && !disposedEarlyNetworkRecorder) {
            await disposeFunction();
            disposedEarlyNetworkRecorder = true;
        }
    };
    const interceptor = {
        startRecordingSession: (0, $5d774bdb3a883001$export$f80553af9d70f9fd),
        stopIntercepting: stopIntercepting
    };
    const maxMsToBlockFor = options.maxMsToBlockFor ?? $d91c442ec5d010f4$var$DEFAULT_MAX_MS_TO_BLOCK_FOR;
    const promise = new Promise((resolve, reject)=>{
        const timeout = maxMsToBlockFor > 0 ? setTimeout(()=>{
            resolve(interceptor);
        }, maxMsToBlockFor) : null;
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = `${0, $7d7683134fbb8fec$export$d16af6ab0c202bae}/record/${(0, $01ff17ace345060a$export$1595d9c512db1389)(options.version ?? null)}/network-recorder.bundle.js`;
        script.onload = function() {
            if (timeout) window.clearTimeout(timeout);
            resolve(interceptor);
        };
        script.onerror = ()=>{
            if (timeout) window.clearTimeout(timeout);
            reject("Meticulous early network recorder failed to initialise.");
        };
        document.head.appendChild(script);
    });
    // Try to load the early network recorder and silence any initialisation error.
    return promise.catch((error)=>{
        console.error(error);
        return interceptor;
    }).finally(()=>{
        if (requestedToStopIntercepting) stopIntercepting();
    });
};


const $57efbd113493cb78$export$e592d04d772ce0ec = async ()=>{
    const disposeFunction = window?.__meticulous?.earlyNetworkRecorder?.dispose;
    if (disposeFunction) await disposeFunction();
};




export {$5d774bdb3a883001$export$9da0cde53b499187 as loadAndStartRecorder, $5d774bdb3a883001$export$f80553af9d70f9fd as tryLoadAndStartRecorder, $d91c442ec5d010f4$export$c0c9d1ed5ecb2675 as tryInstallMeticulousIntercepts, $57efbd113493cb78$export$e592d04d772ce0ec as stopIntercepting};
//# sourceMappingURL=module.js.map
